// 异常路由
const exceptionRoutes = [
  {
    path: "/404",
    meta: {
      title: "404",
    },
    component: () => import("@/views/exception/404/404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    meta: {},
    redirect: "/404",
  },
];
export default exceptionRoutes;
